import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.JournalEntryLines', {
    sectionHeader: 'Journal Entry',
    accountColName: 'Account',
    debitColName: 'Debit',
    creditColName: 'Credit',
    descriptionColName: 'Description',
    payeeTypeColName: 'Type',
    nameColName: 'Name',
    taxCodeColName: 'Tax',
    departmentColName: 'Department',
    classColName: 'Class',
    defaultInputPlaceholder: 'Enter value',
    defaultSelectPlaceholder: 'Select value',
    numberColName: '#',
});
